import { createFileRoute } from '@tanstack/react-router';
import AcademyLoginPage from '@/pages/academy-login.page';

export const Route = createFileRoute('/academy-login')({
  component: AcademyLoginPage,
});
